import * as React from "react";

const Error = (props: any) => (
  <svg width={32} height={32} viewBox="0 0 32 32" {...props}>
    <g fill="none" fillRule="evenodd">
      <circle fill="#C23030" cx={16} cy={16} r={16} />
      <g fill="#FFF" fillRule="nonzero">
        <path d="M17.255 25.078c-.363.363-.84.561-1.333.553a1.892 1.892 0 0 1-1.333-.538 2.023 2.023 0 0 1-.587-1.527 2.15 2.15 0 0 1 .555-1.47 1.801 1.801 0 0 1 1.352-.596c.499-.002.979.212 1.333.597.363.379.566.906.56 1.454a2.047 2.047 0 0 1-.547 1.527zM17.697 11.288l-.494 6.094a5.294 5.294 0 0 1-.306 1.717c-.185.441-.596.718-1.04.698-.44.024-.847-.247-1.027-.684a6.272 6.272 0 0 1-.36-1.789l-.36-5.935c-.067-1.178-.107-1.992-.107-2.501a2.618 2.618 0 0 1 .547-1.746 1.816 1.816 0 0 1 1.44-.64c.615-.035 1.187.347 1.44.96.263.7.382 1.455.347 2.211-.003.54-.03 1.078-.08 1.615z" />
      </g>
    </g>
  </svg>
);

export default Error;

